import { render, staticRenderFns } from "./SurveyResultManagement.vue?vue&type=template&id=5cabf3fa"
import script from "./SurveyResultManagement.vue?vue&type=script&lang=js"
export * from "./SurveyResultManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports